// import { API_HOST_URI } from './constants';
import * as _ from 'lodash';

const data = [
  {
    id: 'config',
    order: 1,
    name: 'User type',
    required: true,
    value: 'Example: office workers',
    placeholder: 'Example: office workers',
    default: '',
    isVisible: true,
    component: 'TextField',
    validators: [
      {
        fn: val => val === '',
        msg: 'Please enter valid name',
      },
    ],
    error: null,
    tooltipInfo: 'Examples: Remote employees, office workers, CAD designers',
  },
  {
    id: 'users',
    order: 2,
    name: 'Number of users',
    required: true,
    value: 100,
    default: 100,
    isVisible: true,
    component: 'Slider',
    validators: [
      {
        fn: (val, props) => {
          if (val > props.max || val < props.min) {
            return true;
          } else {
            return false;
          }
        },
        msg: 'The value must between 50 and 2500',
      },
    ],
    error: null,
    tooltipInfo: 'How many users will be included in this group?',
    props: {
      min: 50,
      max: 2501,
    },
  },
  {
    id: 'pricingModel',
    order: 3,
    name: 'Term options',
    required: true,
    value: 'Commit3Yr',
    default: 'Commit3Yr',
    labelvalue: '3-year term',
    isVisible: true,
    component: 'SelectField',
    validators: [
      {
        fn: val => val == '' || val === null,
        msg: 'Please select the option',
      },
    ],
    error: null,
    tooltipInfo:
      'Select “3-year term” for extended contracts, or “Monthly” to be billed on a month-to-month basis.',
    options: [
      { value: 'Commit3Yr', text: '3-year term' },
      { value: 'PAYGO', text: 'Monthly' },
    ],
  },
  {
    id: 'regionId',
    order: 4,
    name: 'Google Cloud region',
    required: true,
    labelvalue: 'us-east1',
    value: 'us-east1',
    default: 'us-east1',
    isVisible: true,
    link: 'https://cloud.google.com/about/locations',
    apiConfig: {
      url: `${process.env.VUE_APP_ROOT_API}/api/ui/regions`,
      params: [],
      keys: {
        value: 'regionId',
        text: 'regionName',
      },
    },
    filterSelectKey: '',
    component: 'SelectField',
    validators: [
      {
        fn: val => val == '' || val === null,
        msg: 'Please select the option',
      },
    ],
    onChangeCb: ({ fields, curr }) => {
      const updateFieldIds = ['vdaMeterId'];
      const resetFieldIds = ['persistence', 'sessionType'];
      const filteredValueForReset = _.remove(fields, f =>
        resetFieldIds.includes(f.id)
      );

      const filteredFields = _.remove(fields, f =>
        updateFieldIds.includes(f.id)
      );

      for (let _field of filteredValueForReset) {
        if (_field.id === 'sessionType') {
          _field['value'] = 'multi';
        } else {
          _field['value'] = false;
        }
      }
      for (let _field of filteredFields) {
        _field['apiConfig'] = {
          ..._field['apiConfig'],
          url: `${_field.initialApiUrl}${curr.value}&sessionType=multi`,
        };
      }

      const filteredVDAoptions = filteredFields[0].options.filter(
        item => !item.text.startsWith('A')
      );

      return [...fields, ...filteredFields, ...filteredValueForReset].sort(
        (a, b) => a.order - b.order
      );
    },
    error: null,
    tooltipInfo:
      'Select the Google Cloud region where your users and resources are located.',
    options: [{ value: null, text: 'Please Select an option' }],
  },

  {
    id: 'sessionType',
    order: 5,
    name: 'Session type',
    value: 'multi',
    default: 'multi',
    isVisible: false,
    required: true,
    component: 'RadioField',
    error: null,
    options: [
      { value: 'single', text: 'Single session' },
      { value: 'multi', text: 'Multi-session' },
    ],
    tooltipInfo:
      'Select single session for one user per instance. Select multi-session for more than one user per instance',
  },
  {
    id: 'workloadProfileName',
    order: 6,
    name: 'User needs',
    required: false,
    value: 'light',
    default: 'light',
    isVisible: false,
    type: 'number',
    component: 'SelectField',
    error: null,
    options: [
      { value: 'light', text: 'Light' },
      { value: 'medium', text: 'Medium' },
      { value: 'heavy', text: 'Heavy' },
      { value: 'heavy graphics', text: 'Heavy graphics' },
    ],
    onChangeCb: ({ fields, curr }) => {
      const displayField = [
        'iopsPerUser',
        'kbpsPerUser',
        'coresPerUser',
        'memoryMBPerUser',
      ];
      const filteredFields = _.remove(fields, f => displayField.includes(f.id));
      const workloadProfileNamedata = fields.filter(
        item => item.id === 'workloadProfileName'
      )[0];
      if (curr.value === 'light') {
        workloadProfileNamedata.tooltipInfo =
          ' "Light" is ideal for lightweight activities such as data entry and call center apps';
      } else if (curr.value === 'medium') {
        workloadProfileNamedata.tooltipInfo =
          '“Medium” is best for basic apps like Microsoft Word, spreadsheets, and databases';
      } else if (curr.value === 'heavy') {
        workloadProfileNamedata.tooltipInfo =
          '“Heavy” is ideal for more intensive workloads, such as multi-tabbed browser sessions and Microsoft Teams';
      } else {
        workloadProfileNamedata.tooltipInfo =
          ' “Heavy graphics” is best for users who rely on graphics-intensive apps such as 3D CAD and Adobe Photoshop';
      }

      if (curr.value === 'Custom') {
        for (let _field of filteredFields) {
          _field['isVisible'] = true;
        }
      } else {
        for (let _field of filteredFields) {
          _field['isVisible'] = false;
        }
      }
      return [...fields, ...filteredFields].sort((a, b) => a.order - b.order);
    },
    tooltipInfo:
      'Amount of user data storage in GB that each user is expected to be use',
  },
  {
    id: 'iopsPerUser',
    order: 7,
    name: 'User IOPS',
    required: false,
    value: 3.5,
    default: 3.5,
    isVisible: false,
    type: 'number',
    component: 'TextField',
    error: null,
    tooltipInfo: 'input/output operations per second  expected per user',
  },
  {
    id: 'kbpsPerUser',
    order: 8,
    name: 'User Bandwidth',
    required: false,
    value: 190,
    default: 190,
    isVisible: false,
    type: 'number',
    component: 'TextField',
    error: null,
    tooltipInfo: 'outbound bandwidth expected per user in kilobits per seconds',
  },
  {
    id: 'coresPerUser',
    order: 9,
    name: 'User cores',
    required: false,
    value: 0.15,
    default: 0.15,
    isVisible: false,
    type: 'number',
    component: 'TextField',
    error: null,

    tooltipInfo:
      'Number of cores expected for each user to consume on average.',
  },
  {
    id: 'memoryMBPerUser',
    order: 10,
    name: 'User Memory',
    required: false,
    value: 150,
    default: 150,
    isVisible: false,
    type: 'number',
    component: 'TextField',
    error: null,
    tooltipInfo:
      'Amount of memory in Megabyte each user is consuming on average',
  },

  {
    id: 'hours',
    order: 11,
    name: 'Working hours per month',
    required: true,
    value: 180,
    default: 180,
    isVisible: true,
    type: 'number',
    component: 'TextField',
    validators: [
      {
        fn: val => val === 0,
        msg: 'Please enter a value',
      },
    ],
    error: null,
    tooltipInfo:
      'Average number of hours this user type will be working each month',
  },

  // {
  //   id: 'workerOS',
  //   order: 12,
  //   name: 'Workload',
  //   required: true,
  //   value: '2019',
  //   default: '2019',
  //   labelvalue: 'Windows Server 2019',
  //   isVisible: true,
  //   component: 'SelectField',
  //   validators: [
  //     {
  //       fn: val => val == '' || val === null,
  //       msg: 'Please select the option',
  //     },
  //   ],
  //   error: null,
  //   tooltipInfo: 'Choose the operating system used for your VDA servers',
  //   options: [
  //     { value: '10', text: 'Windows 10' },
  //     { value: '2016', text: 'Windows Server 2016' },
  //     { value: '2019', text: 'Windows Server 2019' },
  //   ],
  // },
  {
    id: 'advanceparameters',
    order: 13,
    name: 'Advanced parameters',
    value: false,
    default: false,
    isVisible: true,
    component: 'Toggle',
    onChangeCb: ({ fields, curr }) => {
      let displayField = [];
      const singleUserField = [
        'persistence',
        'vdaMeterId',
        'userDiskMeterId',
        'userDiskSizeInGB',
        'autoscale',
      ];
      const multiUserField = ['persistence', 'vdaMeterId'];
      const closeFieldwhenClosing = [
        'userStorageAmountInGB',
        'userDiskMeterId',
        'userDiskSizeInGB',
        'autoscale',
      ];
      const checkField = ['persistence'];
      const persistenceField = _.filter(fields, f => checkField.includes(f.id));

      if (persistenceField[0].value) {
        displayField = [...singleUserField];
      } else {
        displayField = [...multiUserField];
      }

      const filteredFields = _.remove(fields, f => displayField.includes(f.id));
      const filteredFieldsForClosed = _.remove(fields, f =>
        closeFieldwhenClosing.includes(f.id)
      );

      if (curr.value) {
        for (let _field of filteredFields) {
          _field['isVisible'] = true;
        }
      } else {
        for (let _field of filteredFields) {
          _field['isVisible'] = false;
        }
        for (let _field of filteredFieldsForClosed) {
          _field['isVisible'] = false;
        }
      }
      return [...fields, ...filteredFields, ...filteredFieldsForClosed].sort(
        (a, b) => a.order - b.order
      );
    },
  },
  {
    id: 'persistence',
    order: 14,
    name: 'Select desktop type',
    value: false,
    default: false,
    isVisible: false,
    component: 'RadioField',
    error: null,
    options: [
      { value: true, text: 'Single user desktop' },
      { value: false, text: 'Multi-user desktop' },
    ],
    onChangeCb: ({ fields, curr }) => {
      count += 1;
      const displaySingleField = [
        'userDiskMeterId',
        'userDiskSizeInGB',
        'autoscale',
      ];

      const displayMultiField = ['userStorageAmountInGB'];

      const changeValuesSession = ['sessionType'];
      const currRegionId = ['regionId'];
      const filterRegion = _.filter(fields, f =>
        currRegionId.includes(f.id)
      )[0];

      const filtervda = ['vdaMeterId'];
      const filteredValueconstForVDA = _.remove(fields, f =>
        filtervda.includes(f.id)
      );

      if (count === 1) {
        optionsWithASeries = filteredValueconstForVDA[0].options.filter(item =>
          item.text.startsWith('A')
        );
      }
      const optionswithoutSeriesA = filteredValueconstForVDA[0].options.filter(
        item => !item.text.startsWith('A')
      );

      if (curr.value) {
        for (let _field of filteredValueconstForVDA) {
          _field['apiConfig'] = {
            ..._field['apiConfig'],
            url: `${_field.initialApiUrl}${filterRegion.value}&sessionType=single`,
          };
        }

        const filterSessionField = _.remove(fields, f =>
          changeValuesSession.includes(f.id)
        );
        const newOptionsForVDA = [
          ...optionsWithASeries,
          ...filteredValueconstForVDA[0].options,
        ];
        const filteredFields = _.remove(fields, f =>
          displaySingleField.includes(f.id)
        );
        const filteredinvisibleFields = _.remove(fields, f =>
          displayMultiField.includes(f.id)
        );
        for (let _field of filterSessionField) {
          _field['value'] = 'single';
        }
        for (let _field of filteredFields) {
          if (_field.id == 'autoscale') {
            _field['isVisible'] = true;
          } else if (_field.id == 'userDiskSizeInGB') {
            _field['isVisible'] = true;
            _field['value'] = 128;
          } else {
            _field['isVisible'] = true;

            _field['value'] = _field['options'].filter(
              item => item.text === 'Balanced Persistent Disk'
            )[0].value;
          }
        }
        for (let _field of filteredinvisibleFields) {
          _field['isVisible'] = false;
        }

        filteredValueconstForVDA[0].options = newOptionsForVDA;
        filteredValueconstForVDA[0].value = 'e2-standard-2';

        return [
          ...fields,
          ...filteredFields,
          ...filteredinvisibleFields,
          ...filterSessionField,
          filteredValueconstForVDA[0],
        ].sort((a, b) => a.order - b.order);
      }

      if (!curr.value) {
        for (let _field of filteredValueconstForVDA) {
          _field['apiConfig'] = {
            ..._field['apiConfig'],
            url: `${_field.initialApiUrl}${filterRegion.value}&sessionType=multi`,
          };
        }

        const filterSessionField = _.remove(fields, f =>
          changeValuesSession.includes(f.id)
        );
        const filteredvisibleFields = _.remove(fields, f =>
          displayMultiField.includes(f.id)
        );
        const filteredinvisibleFields = _.remove(fields, f =>
          displaySingleField.includes(f.id)
        );
        for (let _field of filterSessionField) {
          _field['value'] = 'multi';
        }
        for (let _field of filteredvisibleFields) {
          _field['isVisible'] = true;
          _field['value'] = 10;
        }

        for (let _field of filteredinvisibleFields) {
          _field['isVisible'] = false;
          if (_field['id'] === 'autoscale') {
            _field.value = true;
          }
        }

        filteredValueconstForVDA[0].options = optionswithoutSeriesA;
        if (
          optionswithoutSeriesA.find(item => item.text === 'n2d-standard-8')
        ) {
          filteredValueconstForVDA[0].value = 'n2d-standard-8';
        } else {
          filteredValueconstForVDA[0].value = 'c2-standard-8';
        }

        // filteredValueconstForVDA.value = optionswithoutSeriesA.filter(
        //   item => item.text === 'n2d-standard-8'
        // )[0].value;

        return [
          ...fields,
          ...filteredvisibleFields,
          ...filteredinvisibleFields,
          ...filterSessionField,
          filteredValueconstForVDA[0],
        ].sort((a, b) => a.order - b.order);
      }
    },
    tooltipInfo:
      'Select “Single user desktop” if the user changes will be kept across sessions. Select “Multi-user desktop” if the user changes will reset between sessions.',
  },
  {
    id: 'vdaMeterId',
    order: 15,
    name: 'Citrix Virtual Delivery Agent (VDA) instance type',
    value: 'n2d-standard-8',
    default: 'n2d-standard-8',
    required: true,
    isVisible: false,
    initialApiUrl: `${process.env.VUE_APP_ROOT_API}/api/ui/vdas?region=`,
    apiConfig: {
      url: `${process.env.VUE_APP_ROOT_API}/api/ui/vdas?region=us-east1&sessionType=multi`,
      params: [],
      keys: {
        value: 'value',
        text: 'value',
      },
    },
    component: 'SelectField',
    error: null,
    options: [{ value: null, text: 'Select option' }],
    validators: [
      {
        fn: val => val === '',
        msg: 'Please enter valid name',
      },
    ],
    tooltipInfo: 'Select the Citrix VDA instance type',
  },
  {
    id: 'userDiskMeterId',
    order: 16,
    name: 'User disks type',
    value: 'pd-balanced',
    default: 'pd-balanced',
    isVisible: false,
    component: 'SelectField',
    initialApiUrl: `${process.env.VUE_APP_ROOT_API}/api/ui/disks?region=`,
    error: null,
    required: true,
    apiConfig: {
      url: `${process.env.VUE_APP_ROOT_API}/api/ui/disks?region=us-east1`,
      params: [],
      keys: {
        value: 'meterId',
        text: 'skuName',
      },
    },
    options: [{ value: null, text: 'Select option' }],
    tooltipInfo:
      'Select disk type for single session, persistent disk deployments',
  },
  {
    id: 'userDiskSizeInGB',
    order: 17,
    name: 'User disks size',
    required: true,
    value: 128,
    default: 128,
    isVisible: false,
    type: 'number',
    component: 'TextField',
    error: null,
    tooltipInfo:
      'Select disk size in GB for single session, persistent disk deployments',
  },
  // {
  //   id: 'userStorageAmountInGB',
  //   order: 17,
  //   name: 'User storage',
  //   required: true,
  //   value: 100,
  //   default: 100,
  //   isVisible: false,
  //   type: 'number',
  //   component: 'TextField',
  //   validators: [
  //     {
  //       fn: val => val <= 0,
  //       msg: 'Please select the option',
  //     },
  //   ],
  //   error: null,
  //   tooltipInfo:
  //     'Amount of user data storage in GB that each user is expected to be use',
  // },

  {
    id: 'autoscale',
    order: 18,
    name: 'Autoscale',
    required: true,
    value: true,
    default: true,
    isVisible: false,
    component: 'RadioField',
    error: null,
    options: [
      { value: true, text: 'Yes' },
      { value: false, text: 'No' },
    ],
    tooltipInfo:
      'Choose Autoscale to optimize cloud spending by having your deployment intelligently scaled up or down based on usage patterns',
  },
];
let count = 0;
let optionsWithASeries = [];
const formFields = () =>
  new Promise(res => {
    res(data);
  });

export default formFields;
